var map = {
	"./hiragana_hyphen-compressor.gif": "Zfb8",
	"./hiragana_large_a-compressor.gif": "3LPR",
	"./hiragana_large_ba-compressor.gif": "F3qM",
	"./hiragana_large_be-compressor.gif": "CD0/",
	"./hiragana_large_bi-compressor.gif": "jAMB",
	"./hiragana_large_bo-compressor.gif": "B6jN",
	"./hiragana_large_bu-compressor.gif": "cu/J",
	"./hiragana_large_chi-compressor.gif": "+mf5",
	"./hiragana_large_da-compressor.gif": "HDLN",
	"./hiragana_large_de-compressor.gif": "qf+h",
	"./hiragana_large_di-compressor.gif": "H93q",
	"./hiragana_large_do-compressor.gif": "iFRV",
	"./hiragana_large_du-compressor.gif": "t2xd",
	"./hiragana_large_e-compressor.gif": "0Pid",
	"./hiragana_large_ga-compressor.gif": "6Bdd",
	"./hiragana_large_ge-compressor.gif": "5S5p",
	"./hiragana_large_gi-compressor.gif": "k/Fn",
	"./hiragana_large_go-compressor.gif": "XqPE",
	"./hiragana_large_gu-compressor.gif": "XQZJ",
	"./hiragana_large_ha-compressor.gif": "cm2d",
	"./hiragana_large_he-compressor.gif": "tLi7",
	"./hiragana_large_hi-compressor.gif": "6lU4",
	"./hiragana_large_ho-compressor.gif": "NSMh",
	"./hiragana_large_hu-compressor.gif": "efo/",
	"./hiragana_large_i-compressor.gif": "PzTJ",
	"./hiragana_large_ka-compressor.gif": "8lQa",
	"./hiragana_large_ke-compressor.gif": "9k1H",
	"./hiragana_large_ki-compressor.gif": "nvI1",
	"./hiragana_large_ko-compressor.gif": "I6K9",
	"./hiragana_large_ku-compressor.gif": "MCTm",
	"./hiragana_large_ma-compressor.gif": "E5XQ",
	"./hiragana_large_me-compressor.gif": "gG0L",
	"./hiragana_large_mi-compressor.gif": "Umdb",
	"./hiragana_large_mo-compressor.gif": "6FwM",
	"./hiragana_large_mu-compressor.gif": "b0ij",
	"./hiragana_large_na-compressor.gif": "nEWp",
	"./hiragana_large_ne-compressor.gif": "IqhZ",
	"./hiragana_large_ni-compressor.gif": "An/Z",
	"./hiragana_large_nn-compressor.gif": "JIwj",
	"./hiragana_large_no-compressor.gif": "z/n5",
	"./hiragana_large_nu-compressor.gif": "Ve/W",
	"./hiragana_large_o-compressor.gif": "hZjJ",
	"./hiragana_large_pa-compressor.gif": "bowo",
	"./hiragana_large_pe-compressor.gif": "80wm",
	"./hiragana_large_pi-compressor.gif": "3st8",
	"./hiragana_large_po-compressor.gif": "wKCp",
	"./hiragana_large_pu-compressor.gif": "FVSw",
	"./hiragana_large_ra-compressor.gif": "HXe9",
	"./hiragana_large_re-compressor.gif": "VLek",
	"./hiragana_large_ri-compressor.gif": "tPAl",
	"./hiragana_large_ro-compressor.gif": "cVyb",
	"./hiragana_large_ru-compressor.gif": "VpJ7",
	"./hiragana_large_sa-compressor.gif": "lGF7",
	"./hiragana_large_se-compressor.gif": "l/Oa",
	"./hiragana_large_shi-compressor.gif": "x1e7",
	"./hiragana_large_so-compressor.gif": "kDq8",
	"./hiragana_large_su-compressor.gif": "yMol",
	"./hiragana_large_ta-compressor.gif": "HTLS",
	"./hiragana_large_te-compressor.gif": "Hjh7",
	"./hiragana_large_to-compressor.gif": "+K34",
	"./hiragana_large_tsu-compressor.gif": "kqNV",
	"./hiragana_large_u-compressor.gif": "atC6",
	"./hiragana_large_wa-compressor.gif": "qXbr",
	"./hiragana_large_we-compressor.gif": "JZ1s",
	"./hiragana_large_wi-compressor.gif": "AzBJ",
	"./hiragana_large_wo-compressor.gif": "vU9O",
	"./hiragana_large_ya-compressor.gif": "Imgn",
	"./hiragana_large_yo-compressor.gif": "4pW5",
	"./hiragana_large_yu-compressor.gif": "ygx2",
	"./hiragana_large_za-compressor.gif": "P//F",
	"./hiragana_large_ze-compressor.gif": "LDfc",
	"./hiragana_large_zi-compressor.gif": "BYk4",
	"./hiragana_large_zo-compressor.gif": "true",
	"./hiragana_large_zu-compressor.gif": "9A58",
	"./hiragana_small_a-compressor.gif": "QkQs",
	"./hiragana_small_e-compressor.gif": "9qC1",
	"./hiragana_small_i-compressor.gif": "t9g9",
	"./hiragana_small_o-compressor.gif": "lNmF",
	"./hiragana_small_tsu-compressor.gif": "9Cjd",
	"./hiragana_small_u-compressor.gif": "fmOB",
	"./hiragana_small_ya-compressor.gif": "ZlSX",
	"./hiragana_small_yo-compressor.gif": "UuaC",
	"./hiragana_small_yu-compressor.gif": "AGZK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6l0q";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif ^\.\/hiragana_.*\-compressor\.gif$
// module id = 6l0q
// module chunks = 0